import NavBar from "../../components/NavBar/NavBar";
import AuthCheck from "../AuthCheck/AuthCheck";
import "./Layout.scss";

const Layout = ({ showNavbar = true, requiresAuth = false, children }) => {
  const layoutJsx = (
    <>
      {showNavbar && <NavBar />}
      <main className="layout__main">{children}</main>
    </>
  );

  // if the page should be behind authentication
  if (requiresAuth)
    return (
      <div className="layout">
        <AuthCheck>{layoutJsx}</AuthCheck>
      </div>
    );

  // no authentication is required
  return <div className="layout">{layoutJsx}</div>;
};

export default Layout;
